import styled from 'styled-components';

export const LyricsRow = styled.div`
  position: relative;
  padding: 0px;
  /* background-color: white; */
  /* height: calc(100vh - ${props => props.theme.topNavBarHeight}); */
  border-bottom: 1px solid rgba(0,0,0,0.1);
`